import classNames from 'classnames';
import React from 'react';
import ICONS from './icons';

const styles = require('./Icon.module.scss');

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export interface IconProps {
  'aria-hidden'?: boolean | 'true' | 'false';
  'aria-label'?: string;
  className?: string;
  color?: string;
  id?: string;
  name: string;
  role?: string;
  size?: IconSize;
  style?: React.CSSProperties;
  tabIndex?: number;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 'md',
  color,
  className,
  id,
  style,
  tabIndex,
  'aria-hidden': ariaHidden = true,
  'aria-label': ariaLabel,
  role,
}) => {
  const svg = ICONS[name];
  if (!svg) return null;

  const iconClassName = classNames(
    styles['ui-icon'],
    styles[`ui-icon--size-${size}`],
    color && styles[`ui-icon--color-${color}`],
    className,
  );

  const resolvedAriaHidden = ariaLabel ? undefined : ariaHidden;

  return (
    <span
      id={id}
      tabIndex={tabIndex}
      style={style}
      className={iconClassName}
      dangerouslySetInnerHTML={{ __html: svg }}
      aria-hidden={resolvedAriaHidden}
      aria-label={ariaLabel}
      role={ariaLabel ? 'img' : role}
    />
  );
};

export default Icon;
